import 'jquery-hoverintent';
jQuery( $ => {
	const $mobileButton = $( 'button.mobile-nav-toggle, .close-mobile-nav' ),
		$acMenu = $( '.ac-nav-collapse' ),
		$bodyWrap = $( 'body' );

	$mobileButton.on( 'click', e => {
		$mobileButton.toggleClass( 'menu-icon-toggle ' );
		e.stopPropagation();
		$acMenu.toggleClass( 'mobile-open' );
		$bodyWrap.toggleClass( 'mobile-menu-open' );
	} );

	// Toggles submenus
	$( '.toggle-sub-menu' ).on( 'click', function() {
		$( this ).siblings( '.sub-menu-container, .sub-menu' ).toggleClass( 'show-sub-menu' );
		$( this ).toggleClass( 'sub-menu-open' );
		$( this ).parent().toggleClass( 'menu-opened' );
		$acMenu.toggleClass( 'sub-menu-opened' );
	} );

	// Show or hide site overlay on megamenu hover
	const intentIn = function() {
		$( '.site-overlay' ).addClass( 'visible' );
		$( this ).addClass( 'open' );
	};

	const intentOut = function() {
		$( '.site-overlay' ).removeClass( 'visible' );
		$( this ).removeClass( 'open' );
	};

	$( '.megamenu' ).hoverIntent(
		{
			over: intentIn,
			out: intentOut,
			timeout: 300,
		}
	);
} );
